import { Fragment } from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaInstagram, FaTwitter } from "react-icons/fa";

const LINK_ROW_ONE = [
  { to: "/about", label: "About" },
  { to: "/feedback", label: "Help center" },
  { href: "mailto:support@peerpoetry.com", label: "Contact" },
];

const LINK_ROW_TWO = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms" },
];

function FooterLink({ item }) {
  if (item.href) {
    return (
      <a href={item.href} className="peer-sidebar-footer__link">
        {item.label}
      </a>
    );
  }
  return (
    <Link to={item.to} className="peer-sidebar-footer__link">
      {item.label}
    </Link>
  );
}

function LinkRow({ items }) {
  return (
    <div className="peer-sidebar-footer__row">
      {items.map((item, index) => (
        <Fragment key={item.to || item.href}>
          {index > 0 && (
            <span className="peer-sidebar-footer__dot" aria-hidden="true">
              ·
            </span>
          )}
          <FooterLink item={item} />
        </Fragment>
      ))}
    </div>
  );
}

export default function SidebarFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="peer-sidebar-footer" aria-label="Site links">
      <blockquote className="peer-sidebar-footer__quote">
        &ldquo;Poetry is when an emotion has found its thought and the thought has found
        words.&rdquo;
        <cite className="peer-sidebar-footer__cite">— Robert Frost</cite>
      </blockquote>

      <nav className="peer-sidebar-footer__nav" aria-label="Legal and help">
        <LinkRow items={LINK_ROW_ONE} />
        <LinkRow items={LINK_ROW_TWO} />
      </nav>

      <p className="peer-sidebar-footer__brand">
        <span className="peer-sidebar-footer__brand-name">PeerPoetry</span>
        <span className="peer-sidebar-footer__copyright">
          © {currentYear}
        </span>
      </p>

      <div className="peer-sidebar-footer__social">
        <a
          href="https://twitter.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <FaTwitter />
        </a>
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
        <a href="mailto:support@peerpoetry.com" aria-label="Email">
          <FaEnvelope />
        </a>
      </div>
    </footer>
  );
}
